import React from 'react';

import { css } from '@emotion/css';
import { Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Logo from '@/assets/icons/logo-steto-light-full.svg?url';
import { useKeycloak } from '@/auth/KeycloakAuthState';
import { Button } from '@/components/button/Button';
import { useStyles } from '@/hooks/useStyles';
import { ScreenMin } from '@/theme/responsive';

export const Login: React.FC = () => {
  const keycloak = useKeycloak(state => state.keycloak);

  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  return (
    <div className={styles.container}>
      <img className={styles.logo} src={Logo} alt="Steto" />
      <Typography variant="body" className={styles.text}>
        {t('pages.login.disclaimer')}
      </Typography>
      <Button
        buttonType="inverted"
        className={styles.button}
        onClick={() =>
          keycloak.login({
            redirectUri: window.origin,
          })
        }
      >
        {t('pages.login.connection')}
      </Button>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    overflow: clip;
    background-color: ${theme.palette.primary.main};
    padding: 10vh 15vw;
  `,
  logoContainer: css`
    display: inline-block;
    margin: auto;
  `,
  logo: css`
    width: min(500px, 80vw);
    flex: 1 1;
  `,
  text: css`
    flex: 1 1 0;
    color: ${theme.palette.grey[100]};
    margin-top: ${theme.spacing(20)};
    text-align: center;
    min-height: 0;
    ${ScreenMin.MD} {
      max-width: 70%;
    }
    ${ScreenMin.LG} {
      max-width: 50%;
    }
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  button: css`
    margin-top: ${theme.spacing(20)};
  `,
});
